<section class="p-2 p-md-4">


  <div class="card mb-4" *ngIf="unidade">
    <div class="col-12 p-3">
      <label for="pesquisaUnidade">Unidade</label>
      <div class="d-flex align-items-center autocomplete-container">
        <input [inputFormatter]="inputUnidadeFormat" (selectItem)="addFiltroUnidade($event)" [(ngModel)]="unidadeSelecionada" [ngbTypeahead]="pesquisaUnidade" [resultTemplate]="rt_unidade" id="pesquisaUnidade"
          type="text" class="form-control">
        <button *ngIf="unidadeSelecionada" (click)="removeFiltroUnidade()" class="btn btn-xs btn-danger btn-icon">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <ng-template #rt_unidade let-r="result" let-t="term">
        <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
      </ng-template>
    </div>
  </div>

  <div class="card">
    <p-table #dt [columns]="cols"
          styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
          [value]="listaCompostas" selectionMode="single"
          [(selection)]="consulta" [first]="first">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" class="alignRight"></p-sortIcon>
              </th>
              <th style="width: 20%;" class=" pt-0 pb-2" *ngIf="usuario.permissoes.administrador">
                <button (click)="adicionarComposta()" class="btn btn-success btn-sm btn-icon w-100">
                  <i class="mdi mdi-plus"></i>
                  <span>Adicionar</span>
                </button>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData">
              <td>{{rowData.nome}}</td>
              <td class="py-1" *ngIf="usuario.permissoes.administrador">
                <div class="d-flex align-items-center justify-content-center">
                  <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="editarComposta(rowData)" class="btn btn-sm btn-icon mr-3 btn-primary">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                </span>
                <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="delete(rowData)" class="btn btn-sm btn-icon btn-danger">
                    <i class="mdi mdi-delete"></i>
                  </button>
                </span>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length + 1">
                Nenhum resultado encontrado
              </td>
            </tr>
          </ng-template>
        </p-table>

  </div>
</section>